import { render, staticRenderFns } from "./SupInvoiceaddcont.vue?vue&type=template&id=2168e1c6&scoped=true"
import script from "./SupInvoiceaddcont.vue?vue&type=script&lang=js"
export * from "./SupInvoiceaddcont.vue?vue&type=script&lang=js"
import style0 from "./SupInvoiceaddcont.vue?vue&type=style&index=0&id=2168e1c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2168e1c6",
  null
  
)

export default component.exports